let content = {
    categoryDescriptions: {
        policy: "This category assesses the city's governance and regulatory framework related to AI. It reflects the city's efforts to establish rules, guidelines, and strategies to manage and guide AI adoption and use.",
        people: "This category evaluates the city's human capacity and workforce readiness for AI. It reflects the city's efforts to build skills, knowledge, and awareness about AI among its employees.",
        technology: "This category assesses the city's technical infrastructure and implementation of AI. It reflects the city's ability to adopt, integrate, and manage AI technologies."
    },
}

export default content;